import React from 'react';

const LanguageToggle = ({ displayLanguage, setDisplayLanguage, translations }) => {
  return (
    <div
      className="language-toggle-container"
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        zIndex: 1000,
      }}
    >
      <div
        className="language-toggle"
        role="group"
        aria-label="Language selection"
      >
        <button
          type="button"
          className={`language-toggle-btn ${
            displayLanguage === "eng" ? "active" : ""
          }`}
          onClick={() => {
            setDisplayLanguage("eng");
            localStorage.setItem("displayLanguage", "eng");
          }}
          aria-pressed={displayLanguage === "eng"}
          aria-label={translations.switchToEnglish}
        >
          <span className="flag-icon">🇺🇸</span>
          <span className="language-text">English</span>
        </button>
        <button
          type="button"
          className={`language-toggle-btn ${
            displayLanguage === "ja" ? "active" : ""
          }`}
          onClick={() => {
            setDisplayLanguage("ja");
            localStorage.setItem("displayLanguage", "ja");
          }}
          aria-pressed={displayLanguage === "ja"}
          aria-label={translations.switchToJapanese}
        >
          <span className="flag-icon">🇯🇵</span>
          <span className="language-text">Japanese</span>
        </button>
      </div>
    </div>
  );
};

export default LanguageToggle;